import { Method, UpsertRoute } from "../../types";
import { XcoreCore } from "XcoreCore";

export const upsertRoute = (route: Omit<UpsertRoute, "method">, method: Method, core: XcoreCore) =>
  core
    .fetch("/api/route", {
      ...core.getCtx(),
      method,
      body: JSON.stringify(route),
    })
    .then((r) => r.json());
